export const scrollIcon = () => {
  const scrollIconBtn = document.querySelector('.scroll_icon')
  if (scrollIconBtn) {
    scrollIconBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const firstElement = document.querySelectorAll('.section_content')[0] || document.querySelector('.page_content')
      if (firstElement) {
        window.scrollTo({ top: firstElement.offsetTop, behavior: 'smooth' })
      } else {
        // alert('Nothing to scroll')
      }
    })
  }
}
